export default {
  padding: {
    paddingTop: 16,
    paddingBottom: 16,
  },
};
